export var BillingOption = /*#__PURE__*/ function(BillingOption) {
    BillingOption["outOfScope"] = "outOfScope";
    BillingOption["inAgreement"] = "inAgreement";
    return BillingOption;
}({});
